module.exports = __webpack_public_path__ + "img/gplay.7bf5d76e.png";